import {Fragment} from 'react';
import {STYLES} from './styles';
import {TableCell, TableRow, Typography} from '@mui/material';
import {DashboardContractData} from '../../../../../../shared/types/api-v2.types';
import {ContractStatusChip} from '../ContractStatusChip';
import IconButton from '@mui/material/IconButton';
import {SORT_FIELDS, SORT_ICONS, SORT_ORDERS} from './constants';
import {Stack} from '@mui/system';
import {eq} from 'lodash';

type SortField = keyof typeof SORT_FIELDS;
type SortOrder = keyof typeof SORT_ORDERS;

interface SortProps {
  onSort: (field: SortField) => void;
  activeField: SortField;
  activeOrder: SortOrder;
}

const formatDate = (dateString?: string) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString();
};

const renderIcon = (activeField: SortField, activeOrder: SortOrder, field: SortField) => {
  const isNone = !eq(activeField, field) || eq(activeOrder, SORT_ORDERS.none);
  return isNone ? SORT_ICONS[SORT_ORDERS.none] : SORT_ICONS[activeOrder];
};

export const renderTableHeader =
  ({onSort, activeOrder, activeField}: SortProps) =>
  () => {
    return (
      <TableRow sx={STYLES.headerRow}>
        <TableCell sx={{...STYLES.header, width: 60}}>
          <IconButton size="small" onClick={() => onSort(SORT_FIELDS.status)}>
            {renderIcon(activeField, activeOrder, SORT_FIELDS.status)}
          </IconButton>
        </TableCell>
        <TableCell sx={{...STYLES.header, textAlign: 'left'}}>
          <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={1}>
            <Typography sx={STYLES.headerTitle}>Компания</Typography>
            <IconButton size="small" onClick={() => onSort(SORT_FIELDS.companyName)}>
              {renderIcon(activeField, activeOrder, SORT_FIELDS.companyName)}
            </IconButton>
          </Stack>
        </TableCell>
        <TableCell sx={STYLES.header}>
          <Stack direction="row" justifyContent="center" alignItems="center" gap={1}>
            <Typography sx={STYLES.headerTitle}>Номер договора</Typography>
            <IconButton size="small" onClick={() => onSort(SORT_FIELDS.contractNumber)}>
              {renderIcon(activeField, activeOrder, SORT_FIELDS.contractNumber)}
            </IconButton>
          </Stack>
        </TableCell>
        <TableCell sx={STYLES.header}>Дата начала</TableCell>
        <TableCell sx={STYLES.header}>Дата окончания</TableCell>
      </TableRow>
    );
  };

export const renderContractRow = (_: unknown, c: DashboardContractData) => {
  return (
    <Fragment>
      <TableCell style={{...STYLES.cell}}>
        <ContractStatusChip contract={c} />
      </TableCell>
      <TableCell style={{...STYLES.cell, textAlign: 'left'}} align="left">
        {c.contract?.companyName}
      </TableCell>
      <TableCell style={STYLES.cell}>{c.contract?.contractNumber || '-'}</TableCell>
      <TableCell style={STYLES.cell}>{formatDate(c.contract?.startDate)}</TableCell>
      <TableCell style={STYLES.cell}>{formatDate(c.contract?.dueDate)}</TableCell>
    </Fragment>
  );
};
